function initRmxObjects() {
  // portfolio_item.twig
  // blog_item.twig
  $(".about-tiles li").each(function () {
    $(this).prepend(
      $("<span />", {
        class: "about-tiles__number",
        html: "<span><span><span></span></span></span>",
      })
    );
  });

  // blog_items.twig
  // portfolio_items.twig
  $(".blog-all__menu button").click(function () {
    $(this).parent().toggleClass("open");
  });
}
